// extracted by mini-css-extract-plugin
export default {"paper_container":"Sectors_paper_container__MD3H2","header_title":"Sectors_header_title__D1Qa2","search_add_container":"Sectors_search_add_container__UpRW6"};